import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { combineLatest, filter, take } from 'rxjs';
import { PermissionStorageService } from 'src/app/authentication/storages/permission-storage.service';
import { TenantSettingsStoreService } from 'src/app/setting/tenant-settings/services/tenant-settings-store.service';
import { TimeEntryAccessService } from '../services/time-entry-access.service';

@UntilDestroy()
@Component({
    selector: 'app-time-entries',
    templateUrl: './time-entries.component.html',
    styleUrls: ['./time-entries.component.css'],
    standalone: false
})
export class TimeEntriesComponent implements OnInit {

  constructor(
    private permissionStorage: PermissionStorageService,
    private accessService: TimeEntryAccessService,
    private tenantSettingsStore: TenantSettingsStoreService
  ) { }

  // The violations tab shares the reach of "all reports" and additionally needs at least one
  // enabled tenant control (lunch break, open time entries).
  hasWorkTimeControls = false;

  // The "all reports" tab takes TimeEntries.Frontend and somebody to report on: at least one
  // subordinate, or everyone with SearchAll. Resolved by the backend, which alone knows the
  // hierarchy - the same reach the sign rights have.
  canViewAllReports = false;

  // The tabstrip is rendered only once canViewAllReports is resolved, so all tabs are evaluated in
  // a single render pass — Kendo's TabStrip does not reliably pick up a tab added asynchronously.
  ready = false;

  ngOnInit(): void {
    const hasFrontend = (this.permissionStorage.getPermissions() ?? [])
      .includes('Permissions.TimeEntries.Frontend');

    if (!hasFrontend) {
      this.ready = true;
      return;
    }

    // Both inputs are resolved before the tabstrip renders (see `ready`).
    combineLatest([
      this.accessService.manageableEmployees$,
      this.tenantSettingsStore.tenantSettings$.pipe(filter(tenantSettings => !!tenantSettings))
    ])
      .pipe(take(1), untilDestroyed(this))
      .subscribe({
        next: ([employees, tenantSettings]) => {
          this.canViewAllReports = employees.length > 0;
          this.hasWorkTimeControls =
            (tenantSettings.lunchBreakControlEnabled ?? false) || (tenantSettings.openTimeEntryControlEnabled ?? false);
          this.ready = true;
        },
        error: () => this.ready = true
      });
  }

}
